import useConfig from "@lib/use_config";
import Location from "./Location";
import Person from "./Person";

interface Locations {
  locations?: be.Location[];
  onRemove: (id: number) => void;
  onEdit: (pudId: string) => void;
  submitting?: boolean;
}

export default function Locations({
  locations = [],
  onRemove,
  onEdit,
  submitting,
}: Locations): JSX.Element | null {
  const { data: configData } = useConfig(["pudsAsPeople"]);

  return (
    <ul role="list" className="grid items-start grid-cols-1 gap-6 sm:grid-cols-1 max-w-[600px] ">
      {locations.map((loc) => (
        <li
          key={loc.id}
          className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white border-[1px] border-gray-200 shadow"
        >
          {configData?.config.pudsAsPeople ? (
            <Person loc={loc} onRemove={onRemove} onEdit={onEdit} submitting={submitting} />
          ) : (
            <Location loc={loc} onRemove={onRemove} onEdit={onEdit} submitting={submitting} />
          )}
        </li>
      ))}
    </ul>
  );
}
